module.exports = __webpack_public_path__ + "static/media/music-alt-slash.a852b8fb.svg";